import classNames from 'classnames';
import styles from './footer-background.module.scss';

const FooterBackground = () => (
  <div className={classNames(styles.component, 'hasFooterBackgroundTheme')} />
);

FooterBackground.displayName = 'FooterBackground';

export default FooterBackground;
